import classNames from "classnames";
import {
  Snowman,
  Santa,
  XmasSingleBell,
  Candy,
  Package,
  CaiShen,
  BasketOfOranges,
  FireCrackers,
  GoldenScroll,
} from "../svg";
import Image from "next/image";

export default function ProgressTracker({ step }) {
  const steps = [
    { text: "Sender" },
    { text: "Recipient" },
    { text: "Package" },
    { text: "Add-ons" },
    { text: "Review" },
  ];

  const xmasElements = [
    <Santa
      key="Santa"
      className={classNames("w-[40px] h-[45px] sm:w-auto sm:h-auto")}
    />,
    <Snowman
      key="Snowman"
      className={classNames("w-[32px] h-[45px] sm:w-auto sm:h-auto")}
    />,

    <Package
      key="Present"
      className={classNames("w-[32px] h-[45px] sm:w-auto sm:h-auto")}
    />,
    <XmasSingleBell
      key="SingleBell"
      className={classNames(
        "w-[30px] h-[45px] sm:w-auto sm:h-auto translate-y-1"
      )}
    />,
    <Candy
      key="Candy"
      className={classNames(
        "w-[32px] h-[45px] sm:w-auto sm:h-auto translate-y-0.5"
      )}
    />,
  ];

  const lunarNewYearElements = [
    <CaiShen
      key="CaiShen"
      className={classNames("w-[42px] h-[42px] sm:w-auto sm:h-auto")}
    />,
    <div
      key="Dragon"
      className={classNames(
        "w-[42px] h-[42px] sm:w-auto sm:h-auto",
        "translate-y-0.5 sm:translate-y-1 -translate-x-0.5"
      )}
    >
      <Image
        src="/images/lunar-new-year/stumpy-dragon.png"
        alt="dragon"
        height={52}
        width={52}
      />
    </div>,
    <BasketOfOranges
      key="BasketOfOranges"
      className={classNames("w-[32px] h-[42px] sm:w-auto sm:h-auto")}
    />,
    <FireCrackers
      key="FireCrackers"
      className={classNames("w-[30px] h-[42px] sm:w-auto sm:h-auto")}
    />,
    <GoldenScroll
      key="GoldenScroll"
      className={classNames("w-[26px] h-[42px] sm:w-auto sm:h-auto")}
    />,
  ];

  const ProgressCircle = ({ index, step }) => {
    if (index < step) {
      return (
        <div className="rounded-full bg-gray-4 w-[32px] h-[32px] md:w-[40px] md:h-[40px] flex items-center justify-center font-semibold z-[1]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="white"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
      );
    }
    if (index === step) {
      return (
        <div
          className={classNames(
            "flex items-center justify-center rounded-full bg-background-gray",
            "w-[32px] h-[32px] md:w-[40px] md:h-[40px] z-[1] border border-dark-purple shadow-border-focus"
          )}
        >
          <div className="flex items-center justify-center rounded-full bg-dark-purple w-[26px] h-[26px] md:w-[30px] md:h-[30px]">
            <span className="text-sm md:text-base font-semibold text-white">
              {index + 1}
            </span>
          </div>
        </div>
      );
    }

    return (
      <div className="flex items-center justify-center rounded-full bg-gray-3 w-[32px] h-[32px] md:w-[40px] md:h-[40px] z-[1]">
        <span className="text-sm md:text-base font-semibold">{index + 1}</span>
      </div>
    );
  };

  return (
    <>
      <div className="max-w-3xl mx-auto pt-8 pb-6 md:pt-10 md:pb-7">
        <div className="flex items-center justify-between w-[92%] sm:w-[80%] lg:w-[70%] mx-auto relative">
          {steps.map((ele, index) => {
            return (
              <div
                className="flex flex-col place-items-center w-max"
                key={index}
              >
                {process.env.NEXT_PUBLIC_THEME === "XMAS" ? (
                  <div
                    className={classNames(
                      "z-[1]",
                      step < index ? "grayscale" : ""
                    )}
                  >
                    {xmasElements[index]}
                  </div>
                ) : process.env.NEXT_PUBLIC_THEME === "LUNAR_NEW_YEAR" ? (
                  <div
                    className={classNames(
                      "z-[1]",
                      step < index ? "grayscale" : ""
                    )}
                  >
                    {lunarNewYearElements[index]}
                  </div>
                ) : (
                  <ProgressCircle index={index} step={step} />
                )}
                <p
                  className={classNames(
                    "mt-2 text-xs md:text-sm",
                    index === step
                      ? "text-light-purple"
                      : index < step
                      ? "text-subheading-gray"
                      : "text-gray-3"
                  )}
                >
                  {ele.text}
                </p>
              </div>
            );
          })}
          <hr
            className={classNames(
              "absolute border-border-gray w-[90%] left-0 right-0 mx-auto",
              process.env.NEXT_PUBLIC_THEME === "XMAS"
                ? "top-[28px] sm:top-[38px]"
                : process.env.NEXT_PUBLIC_THEME === "LUNAR_NEW_YEAR"
                ? "top-[28px] sm:top-[36px]"
                : "top-[16px] sm:top-[20px]"
            )}
          />
        </div>
      </div>
    </>
  );
}
